var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 11.9988H21.9979",
    stroke: "#EF4444",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6645 11.9988V21.3313C20.6645 21.9979 19.9979 22.6645 19.3313 22.6645H12.6652C11.9986 22.6645 11.332 21.9979 11.332 21.3313V11.9988",
    stroke: "#EF4444",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 11.9989V10.6657C13.332 9.99913 13.9986 9.33252 14.6652 9.33252H17.3317C17.9983 9.33252 18.6649 9.99913 18.6649 10.6657V11.9989",
    stroke: "#EF4444",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.665 15.332V19.3317",
    stroke: "#EF4444",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3311 15.332V19.3317",
    stroke: "#EF4444",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9985,
    height: 15.9985,
    fill: "white",
    transform: "translate(7.99902 7.99927)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e03ae168cc37b687f214996e10186ac3.svg";
export { ForwardRef as ReactComponent };